import { FormInlineErrorModule } from './shared/component/form-inline-error/form-inline-error.module';
import { LoginModule } from './pages/login/login.module';
import { LandingPageModule } from './pages/landing-page/landing-page.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NavigationService } from './shared/services/navigation.service';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderComponent } from './shared/component/loader/loader.component';
import { LoaderService } from './shared/services/loader.service';
import { HttpErrorInterceptor } from './shared/error-handling/http-error.interceptor';
import { SharedComponentsModule } from './shared/modules/sharedComponentsModule';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CookieService, PageActionService, SessionStorageService, UtilityService, TimeoutService ,RequestInterceptor} from '@collab/comp-library';
import { PasswordResetPageModule } from './pages/password-reset-page/password-reset-page.module';
import { ContactUsComponent } from './shared/component/contact-us/contact-us.component';
import { environment } from 'src/environments/environment';
import { SigninCallbackComponent } from './pages/signin-callback/signin-callback.component';
import { HomeComponent } from './home.component';


@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        LoaderComponent,
        ContactUsComponent,
        SigninCallbackComponent,
        HomeComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        LoginModule,
        PasswordResetPageModule,
        LandingPageModule,
        ReactiveFormsModule,
        FormsModule,
        FormInlineErrorModule,
        SharedComponentsModule,
        NgIdleKeepaliveModule.forRoot(),
    ],
    providers: [
        NavigationService,
        LoaderService,
        UtilityService,
        CookieService,
        SessionStorageService,
        PageActionService,
        TimeoutService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true }
    ],
    bootstrap: [ AppComponent ]
  })
export class AppModule {}
